/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
  <v-row>
       <v-card style="margin:auto;margin-top:40px;" width="1200px">

         <!-- ======================= NOVO LOTE ============================ -->
             <template>
              <v-row justify="center">
                <v-dialog v-model="showLoteModal" persistent max-width="600px">
  <v-form
    ref="formLote"
    v-model="validLote"
    lazy-validation
  >
                  <v-card>
                    <v-card-title style="background-color:#006699;color:white;">
                      <span class="headline">Novo Lote</span>
                    </v-card-title>
                    <v-alert v-model="alertLote" type="success">
                    Lote cadastrado com sucesso
                  </v-alert>
                    <v-card-text>
                      <v-container>

                        <v-row>
                             <v-col cols="12" sm="6" md="12">
                                <v-text-field  v-model="editedItemLote.descricao" :rules="ruleRequired"  label="Descrição do lote"></v-text-field>
                            </v-col>
                             <v-col cols="12" sm="6" md="6">
                               <template>
                                  <v-menu
                                    ref="menuFab"
                                    v-model="menuFab"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-text-field

                                        v-model="editedItemLote.dataFabricacao"
                                        :rules="[v => !!v || 'Campo obrigatorio!']"
                                        label="Data de Fabricação"
                                        prepend-icon="event"
                                        readonly
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="dataFabrico"
                                      ref="picker"
                                      @change="saveDataFabrico"
                                    ></v-date-picker>
                                  </v-menu>
                                </template>
                            </v-col>
                             <v-col cols="12" sm="6" md="6">
                                <template>
                                <v-menu
                                  ref="menuExp"
                                  v-model="menuExp"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-text-field

                                      v-model="editedItemLote.dataValidade"
                                      :rules="[v => !!v || 'Campo obrigatorio!']"
                                      label="Data de Expiração"
                                      prepend-icon="event"
                                      readonly
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="dataExpiracao"
                                    ref="picker"
                                    
                                  @change="saveDataExpiracao"
                                  ></v-date-picker>
                                </v-menu>
                            </template>
                            </v-col>
                        </v-row>

                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color:white;" color="green darken-1" :disabled="!validLote" @click="saveLote()">Guardar</v-btn>
                      <v-btn    @click="showLoteModal = false">Cancelar</v-btn>
                    </v-card-actions>
                  </v-card>
  </v-form>
                </v-dialog>
              </v-row>
              </template>
         <!-- ==================== FIM NOVO LOTE =========================== -->

         <!-- =================== Faturas Guardadas ======================== -->
            <v-dialog
                v-model="dialogStockArmazenado"
                max-width="890"
              >
                <v-card>
                  <v-card-title class="headline" style="color:white;background-color:#006699;">Restauração de Faturas Guardadas</v-card-title>
        <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="70"></v-progress-circular>
            </v-overlay>
                  <v-card-text>
                     <!-- =============== Tabela ========================================= -->

                                      <template>
                                          <v-card>
                                            <v-card-title>
                                              Lista de Faturas
                                              <v-spacer></v-spacer>
                                              <v-text-field
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                              ></v-text-field>
                                            </v-card-title>
                                            <v-data-table
                                              :headers="headersFatura"
                                              :items="stockGuardado"
                                              :search="search"
                                            >
                                                <template v-slot:item.items="{ item }">
                                                    <v-btn small color="green" fab style="color:white" @click="VerItems(item)"><v-icon>view_list</v-icon></v-btn>
                                                </template>
                                                <template v-slot:item.restaurar="{ item }">
                                                    <v-btn small color="green" fab style="color:white" @click="RealodStock(item)"><v-icon>restore</v-icon></v-btn>
                                                </template>
                                            </v-data-table>
                                          </v-card>
                                        </template>

                     <!-- =============== END TABELA ============================================= -->
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogStockArmazenado = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
         <!-- ================== END do DIALOGO========================================= -->

         <!-- =================== Faturas Guardadas ======================== -->
            <v-dialog
                v-model="dialogStockArmazenadoItems"
                max-width="890"
              >
                <v-card>
                  <v-card-title class="headline" style="color:white;background-color:#006699;">Items de  Faturas Guardadas</v-card-title>

                  <v-card-text>
                    <v-row>
                       <v-col md="2"><span style="font-weight:bold;">Fatura:</span></v-col>
                       <v-col md="6">{{itemFatura.Fatura}}</v-col>
                    </v-row>
                    <v-row>
                       <v-col md="2"><span style="font-weight:bold;">Operação:</span></v-col>
                       <v-col md="6">{{itemFatura.operacaoStock}}</v-col>
                    </v-row>
                    <v-row>
                       <v-col md="3"><span style="font-weight:bold;">Data de operação:</span></v-col>
                       <v-col md="6">{{itemFatura.data_}}</v-col>
                    </v-row>
                     <!-- =============== Tabela ========================================= -->

                                      <template>
                                          <v-card>
                                            <v-card-title>
                                              Items da Fatura
                                              <v-spacer></v-spacer>
                                              <v-text-field
                                                v-model="search"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                              ></v-text-field>
                                            </v-card-title>
                                            <v-data-table
                                              :headers="headersFaturaItems"
                                              :items="stockGuardadoItems"
                                              :search="search"
                                            >
                                                <template v-slot:item.produto="{ item }">
                                                    <span>{{item.produto.descricao}}</span>
                                                </template>
                                            </v-data-table>
                                          </v-card>
                                        </template>

                     <!-- =============== END TABELA ============================================= -->
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogStockArmazenadoItems = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
         <!-- ================== END do DIALOGO Items da Fatura========================================= -->

         <v-card-title style="background-color:#006699;color:white;font-size:20px;">
           <span>Actualização do Stock</span>
          </v-card-title>
           <v-alert
              v-model="alert"
              dismissible
              :type="alertType"
              border="left"
              :icon="iconAlert"
              transition="scale-transition"
              :style="colorAlert"
              elevation="2"
              colored-border
            >
            {{msgAlert}}
          </v-alert>
        <v-card-text>
          <span style="font-size:15px;font-weight:bold;">Dados Gerais</span>
          <v-container>
            <v-form
               ref="form"
                v-model="valid"
                lazy-validation
            >
            <v-row style="border:1px solid #ccc;">
               <v-col cols="12" sm="6" md="4">
                <v-combobox
                    @change="SelecionaOperacao()"
                    v-model="editedItem.operacao"
                    :items="operacoesStocks"
                    prepend-icon="search"
                    item-text="descricao"
                    item-value="descricao"
                    :rules="ruleRequired"
                    label="Selecione a operação"
                    filled
                    outlined
                ></v-combobox>
              </v-col>
               <v-col cols="12" sm="6" md="3">
                  <v-autocomplete
                    v-if="editedItem.operacao.descricao === 'Entrada de Stock'"
                    v-model="editedItem.faturaCompra"
                    :items="faturas"
                    :loading="isLoadingFt"
                    :search-input.sync="searchNF"
                    color="primary"
                    item-text="referencia"
                    item-value="pkFaturaCompra"
                    label="Nº da Factura"
                    placeholder="Digite o Nº da Factura"
                    prepend-icon="search"
                    return-object
                    @change="SelecionaFatura"
                    @click="ListagemFaturas()"
                    :rules="ruleRequired"
                    filled
                    outlined
              >
              <template v-slot:item="{ item }">
                       <v-list-item-avatar v-if="item.icone"
                        color="indigo"
                        class="headline font-weight-light white--text"
                       >
                      <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.referencia"></v-list-item-title>
                    </v-list-item-content>
              </template>
              </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="4"  v-if="editedItem.operacao.descricao === 'Entrada de Stock'">
                 <v-chip > Valor Total da Factura:</v-chip> <v-chip><span style="font-size:30px;">{{ valorFatura}}</span></v-chip>
              </v-col>
            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
  </v-row>
  <v-overlay :value="overlay">
      <v-progress-circular color="green" indeterminate size="70"></v-progress-circular>
    </v-overlay>
  <v-row>
      <v-card style="margin:auto;margin-top:2px;"   width="1200px">
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
        <v-card-title style="font-size:20px;">
           <span>Produtos</span>
          <div style="font-size:15px;margin-left:50px;" v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>
        </v-card-title>
          <v-data-table
          :headers="headers"
          :items="Produtos"
          :search="search"
            hide-default-footer
          >
            
           <template v-slot:item.produto="{ item }">
              <v-combobox
                v-model="Produtos[Produtos.indexOf(item)].produto"
                :items="ProdutosGeral"
                hide-selected
                filled
                outlined
                background-color="#ffff99"
                item-text="descricao"
                item-value="codigoBarra"
                label="Produto"
                prepend-icon="search"
                :rules="ruleRequired"
                @click="Listagem_Produtos_recentes()"
                @change="SelecionaProduto(Produtos.indexOf(item))"
              >
              <template v-slot:item="{ item }">
                    <v-list-item-avatar v-if="item.icone"
                      color="indigo"
                      class="headline font-weight-light white--text"
                    >
                      <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.descricao"></v-list-item-title>
                    </v-list-item-content>
                  </template>
              </v-combobox>
           </template>
           <template v-slot:item.quantidade="{ item }">
              <v-text-field v-model="Produtos[Produtos.indexOf(item)].qtd" outlined :disabled="disabilitaOutros[Produtos.indexOf(item)]" :background-color="(disabilitaOutros[Produtos.indexOf(item)])?'#ccc':'#ffff99'" @keyup="CalculaPrecoUnitario(Produtos.indexOf(item))" :rules="ruleRequired" filled label="Qtd"></v-text-field>
           </template>
           <template v-slot:item.precoUnitario="{ item }">
             <p>{{Produtos[Produtos.indexOf(item)].precoUnitario}}</p>
              <!-- <v-text-field  v-model="Produtos[Produtos.indexOf(item)].precoUnitario"  outlined :disabled="true" @keyup="CalculaValorTotal(Produtos.indexOf(item))"    filled label="Preço"></v-text-field> -->
           </template>
           <template v-slot:item.desconto="{ item }">
              <v-text-field v-model="Produtos[Produtos.indexOf(item)].desconto" outlined :disabled="disabilitaOutros[Produtos.indexOf(item)]" @keyup="CalculaValorTotalDesconto(Produtos.indexOf(item))" :background-color="(disabilitaOutros[Produtos.indexOf(item)])?'#ccc':'#ffff99'" v-money="money" filled label="Desconto"></v-text-field>
           </template>
           <template v-slot:item.unidade="{ item }">
             <p>{{Produtos[Produtos.indexOf(item)].unidade}}</p>
              <!-- <v-text-field v-model="Produtos[Produtos.indexOf(item)].unidade" outlined :disabled="true" v-m filled label="Unidade"></v-text-field> -->
           </template>
           <template v-slot:item.lote="{ item }">
              <!-- <v-text-field v-model="Produtos[Produtos.indexOf(item)].lote" background-color="#ffff99" :rules="ruleRequired" filled label="Lote"></v-text-field>-->
              <v-combobox
                v-model="Produtos[Produtos.indexOf(item)].lote"
                :items="lotes"
                :search-input.sync="search"
                hide-selected
                filled
                outlined
                :background-color="(disabilitaOutros[Produtos.indexOf(item)])?'#ccc':'#ffff99'"
                item-text="descricao"
                item-value="descricao"
                label="Selecione"
                prepend-icon="search"
                :disabled="disabilitaOutros[Produtos.indexOf(item)]"
                small-chips
                :rules="ruleRequired"
                @click="Listagem_Lotes_recentes()"
                @change="SelecionaLote(Produtos.indexOf(item))"
              >
              <template v-slot:item="{ item }">
                    <v-list-item-avatar v-if="item.icone"
                      color="indigo"
                      class="headline font-weight-light white--text"
                    >
                      <v-btn  icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.descricao"></v-list-item-title>
                    </v-list-item-content>
                  </template>
              </v-combobox>
           </template>
           <template v-slot:item.validade="{ item }">
             <p :style="(!loteExpirado)?'font-size:11px;font-weight:bold;color:green':'font-size:11px;font-weight:bold;color:red;'">{{Produtos[Produtos.indexOf(item)].validade}}</p>
              <!-- <v-text-field  v-model="Produtos[Produtos.indexOf(item)].validade"  :disabled="true" outlined filled label="D.Validade"></v-text-field> -->
           </template>
           <template v-slot:item.custoCompra="{ item }">
              <v-text-field  v-model="Produtos[Produtos.indexOf(item)].custoCompra" :disabled="disabilitaOutros[Produtos.indexOf(item)]" :background-color="(disabilitaOutros[Produtos.indexOf(item)])?'#ccc':'#ffff99'" v-money="money" outlined  filled @keyup="CalculaPrecoUnitario(Produtos.indexOf(item))" label="Custo"></v-text-field>
           </template>
           <template v-slot:item.delete="{ item }">
              <v-btn small color="#de143c" fab style="color:white;margin-top:-24px;" @click="remover(Produtos.indexOf(item))"><v-icon>delete</v-icon></v-btn>
           </template>
          </v-data-table>
          <v-card-footer>
            <!-- <v-btn color="primary" @click="showItems()" :disabled="!stockGuardado.length"><v-icon>save</v-icon>{{stockGuardado.length}}</v-btn> -->
            <v-btn  color="#08cc0b" @click="AddTabela()" :disabled="linhasVaziasEncontradas || !valid || editedItem.faturaCompra === null || TotalInvalido || mesmoLote" fab style="color:white;float:right;margin-top:-20px;"><v-icon>add</v-icon></v-btn>
            <v-btn style="margin-right:10px;float:right;color:white;margin-top:-4px;" v-if="false" @click="Guardar()" :disabled="linhasVaziasEncontradas || !Produtos.length || TotalInvalido || mesmoLote" color="green" >Guardar</v-btn>
           <v-btn style="margin-top:-5px;margin-right:5px;float:right;" color="primary" @click="Concluir()" :disabled="linhasVaziasEncontradas || !Produtos.length || loteExpirado || TotalInvalido || mesmoLote || totalGeral !== utilitariosData.MoneyValueToInteger(valorFatura)">Finalizar</v-btn>
          </v-card-footer>
  </v-form>
      </v-card>
  </v-row>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask, money: VMoney },
  data: () => ({
    util: utilitarios,
    money: {
      decimal: ',',
      thousands: '.',
      suffix: '',
      precision: 2,
      masked: false
    },
    overlay: false,
    utilitariosData: utilitarios,
    produtosTotal: 0,
    totalGeral: 0,
    ProdutosGeral: [],
    disabilitaOutros: [],
    Produtos: [],
    valorDisponivel: '',
    mesmoLote: false,
    showLoteModal: false,
    dialogFatura: false,
    loteExpirado: true,
    menuCompra: null,
    isLoading_: false,
    dialogStockArmazenado: false,
    dialogStockArmazenadoItems: false,
    isLoadingFt: false,
    isLoadingForn: false,
    validLote: true,
    isLoadingF: false,
    alertLote: false,
    search: '',
    searchForn: [],
    searchNF: '',
    menuFab: null,
    menuExp: null,
    datasExpiracao: [],
    dataFabrico: '',
    dataExpiracao: '',
    dataCompra: '',
    valid: true,
    valid1: true,
    files: [],
    taxa_iva: [],
    faturas: [],
    menuExpss: [],
    fornecedores: [],
    valorFatura: 0,
    descricaoUnidade: [],
    stockGuardado: [],
    descricao_isencao_iva: [],
    descricao_isencao_ivaprecoFiltered: [],
    taxa_ivaPrecoSelected: null,
    dataCompraSelected: null,
    disabilita_ivaPreco: true,
    produtos: [],
    disabilitaDisponivel: true,
    disabilitaQtd: true,
    alert: false,
    iconAlert: 'done',
    alertType: 'success',
    colorAlert: 'color:green;',
    msgAlert: '',
    headers: [
     
      { text: 'Produto', value: 'produto' },
      { text: 'Quant.', value: 'quantidade' },
      { text: 'Preço unitário', value: 'precoUnitario' },
      { text: 'Desconto', value: 'desconto' },
      { text: 'Unidade', value: 'unidade' },
      { text: 'Lote', value: 'lote' },
      { text: 'D.Validade', value: 'validade' },
      { text: 'Valor Total', value: 'custoCompra' },
      { text: 'Deleta', value: 'delete' }
    ],
    headersFatura: [
      {
        text: 'Identificação da Fatura',
        align: 'start',
        sortable: false,
        value: 'Fatura'
      },
      { text: 'Operação', value: 'operacaoStock' },
      { text: 'Data de entrada', value: 'data_' },
      { text: 'Ver Items', value: 'items' },
      { text: 'Restaurar Factura', value: 'restaurar' }
    ],
    operacoesStocks:
    [
      { descricao: 'Entrada de Stock' },
      { descricao: 'Saida de Stock' }
    ],
    disponiblidade:
    [
      { id: 1, descricao: 'Não disponível' },
      { id: 2, descricao: 'Disponível' }
    ],
    lotes: [],
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequiredMotivo: [value => !!value || 'campo obrigatorio'],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],

    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    itemFatura: {
      Fatura: '',
      dataEntrada: '',
      dataSaida: null,
      data_: '',
      fkFatura: 4,
      operacao: 1,
      operacaoStock: '',
      pkStockGuardado: '',
      status_: '',
      tabela: null
    },
    editedItem: {
      dataExpiracao: '',
      dataFabrico: '',
      produto: null,
      lote: '',
      quantidade: 0,
      operacao: '',
      observacao: '',
      fornecedor: null,
      custoCompra: '',
      custoTransporte: '',
      precoUnitario: 0,
      impostoIva: '',
      motivoIsencao: '',
      numeroFatura: '',
      ficheiroFatura: [],
      qtdVenda: 0,
      disponivel: '',
      faturaCompra: null
    },
    editedItemDefault: {
      dataExpiracao: '',
      dataFabrico: '',
      produto: null,
      lote: '',
      quantidade: 0,
      operacao: '',
      observacao: '',
      fornecedor: null,
      custoCompra: 0,
      custoTransporte: 0,
      precoUnitario: 0,
      impostoIva: '',
      motivoIsencao: '',
      numeroFatura: '',
      
      ficheiroFatura: [],
      qtdVenda: 0,
      disponivel: '',
      faturaCompra: null
    },
    stockGuardadoItems: [],
    editedItemFactura: {
      numeroFatura: '',
      data: '',
      valorTotal: '',
      file: null,
      fkFornecedor: '',
      fkEntidade: ''
    },
    editedItemLote: {
      descricao: '',
      dataValidade: '',
      dataFabricacao: ''
    },
    editedItemLoteDefault: {
      descricao: '',
      dataValidade: '',
      dataFabricacao: ''
    },
    headersFaturaItems: [
      {
        text: 'Código de Barra',
        align: 'start',
        sortable: false,
        value: 'codBarra'
      },
      { text: 'Produto', value: 'produto' },
      { text: 'Unidade', value: 'unidade' },
      { text: 'Qtd', value: 'qtd' },
      { text: 'Preço de Unitário', value: 'precoUnitario' },
      { text: 'Custo Total', value: 'custoCompra' }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    },
    linhasVaziasEncontradas () {
      if (this.Produtos.filter(p => p.unidade === '').length) return true; return false
    },
    verificaProdutos () {
      let produtosTotal = 0
      this.Produtos.forEach(element => {
        produtosTotal += utilitarios.MoneyValueToInteger(element.custoCompra)
      })
      return produtosTotal
    },
    TotalInvalido () {
      let produtosTotal = 0
      this.Produtos.forEach(element => {
        produtosTotal += utilitarios.MoneyValueToInteger(element.custoCompra)
      })
      produtosTotal += this.valorDisponivel
      return (produtosTotal > ((this.editedItem.faturaCompra === null) ? 0 : this.editedItem.faturaCompra.totalFatura))
    }

  },

  watch: {
    menuCompra (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val != null) this.tab = 0
      else this.tab = null
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 1) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }
      if (val.length >= 1) { return this.initializeProdutos(val) }
    },
    searchForn (val) {
      // Items have already been loaded
      if (val.length >= 2) {
      // Items have already been requested
        if (!this.lotes.filter(t => t.descricao.includes(val)).length) {
          this.lotes = []
          return this.PesquisarLotes(val)
        }
      }

      if (val.length >= 2) { return this.PesquisarLotes(val) }
    },
    searchNF (val) {
      // Items have already been loaded
      if (val.length >= 1) {
      // Items have already been requested
        if (!this.faturas.filter(t => t.referencia.includes(val)).length) {
          this.faturas = []
          return this.PesquisarFaturas(val)
        }
      }

      if (val.length >= 1) { return this.PesquisarFaturas(val) }
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeTaxaIva()
    this.initializeIsencaoIva()
    this.ListagemFaturas()
    this.InitializeStockGuardado()
    this.$store.state.fromStock = false
  },

  methods: {
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },

    AddTabela () {
      if (this.$refs.form.validate()) {
        let params =
        {
          pkProduto: '',
          codBarra: '',
          produto: '',
          qtd: '1',
          precoUnitario: '0,00',
          unidade: 'unid.',
          lote: '',
          validade: 'N/A',
          custoCompra: '',
          custoCompraInteiro: '',
          stock_min: '',
          stock_max: '',
          desconto: ''
        }
        this.disabilitaOutros.push(true)
        this.Produtos.push(params)
      }
    },

    remover (indice) {
      this.Produtos.splice(indice, 1)
      this.fornecedores = []
      this.mesmoLote = false
      this.disabilitaOutros.splice(indice, 1)
    },
    async initializeProdutos (searchBy) {
      try {
        //   let  payload =""
        this.isLoading_ = true
        this.produtos = await axios
          .get('/produtosFindallForStock/' + searchBy)
          .then(res => res.data)
        this.isLoading_ = false
      } catch (error) {
        this.isLoading_ = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async InitializeStockGuardado () {
      try {
        //   let  payload =""
        this.isLoading_ = true
        this.stockGuardado = await axios
          .get('/stockGuardadoFindAll')
          .then(res => res.data)
        this.isLoading_ = false
      } catch (error) {
        this.isLoading_ = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async PesquisarFornecedores (searchBy) {
      try {
        //   let  payload =""
        this.isLoadingForn = true
        this.fornecedores = await axios
          .get('/FornecedorFindAll/' + searchBy)
          .then(res => res.data)
        this.isLoadingForn = false
      } catch (error) {
        this.isLoadingForn = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    CarregaProduto (item) {
      let index = this.Produtos.indexOf(item)
      let codigoBarra = this.Produtos[index].codBarra
      if (codigoBarra !== undefined) {
        // Verifica se este codigo de barra ja foi selecionado
        if (codigoBarra !== '') {
          // let existe = this.Produtos.filter(p => p.codBarra === codigoBarra)
          this.ObterProduto(codigoBarra, index)
        }
      } else console.log('Não preenchido')
    },
    async  ObterProduto (codigoBarra, index) {
      try {
        //   let  payload =""
        this.overlay = true
        let result = await axios
          .get('/produtosFind/' + codigoBarra)
          .then(res => res.data)
        if (result.length) {
          this.preencheCampos(result, index)
          this.disabilitaOutros[index] = false
        } else {
          this.Limpar(index)
          this.text = 'Código de Barra desconhecido'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    preencheCampos (produto, index) {
      this.Produtos[index].stock_max = produto[0].stock_max
      this.Produtos[index].stock_min = produto[0].stock_min
      this.Produtos[index].pkProduto = produto[0].pkProduto
      this.Produtos[index].produto = produto[0].produto
      this.Produtos[index].unidade = (produto[0].unidade === 2) ? 'Kg' : 'unid.'
    },

    preencheCamposByItem (item, index) {
      this.Produtos[index].codBarra = item.codigoBarra
      this.Produtos[index].stock_max = item.stock_max
      this.Produtos[index].stock_min = item.stock_min
      this.Produtos[index].pkProduto = item.pkProduto
      this.Produtos[index].unidade = (item.unidade === 2) ? 'Kg' : 'unid.'
      this.disabilitaOutros[index] = false
    },

    async  PesquisarFaturas (val) {
      // try {
      //   //   let  payload =""
      //   this.isLoadingFt = true
      //   this.faturas = await axios
      //     .get('/FaturaFindAll/' + val)
      //     .then(res => res.data)
      //   this.faturas.push({ pkFaturaCompra: 0, referencia: 'Nova Factura', icone: true })
      //   this.isLoadingFt = false
      // } catch (error) {
      //   this.isLoadingFt = false
      //   this.text = error
      //   this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      // }
    },

    async  PesquisarLotes (val) {
      try {
        //   let  payload =""
        this.isLoadingLote = true
        this.lotes = await axios
          .get('/loteFind/' + val)
          .then(res => res.data)
        this.isLoadingLote = false
        this.lotes.push({ descricao: 'Novo Lote', icone: true, pkLote: -1 })
      } catch (error) {
        this.isLoadingLote = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  Listagem_Produtos_recentes () {
      try {
        //   let  payload =""
        this.overlay = true
        this.ProdutosGeral = await axios
          .get('/Listagem_Produtos_recentesForStock')
          .then(res => res.data)
        this.overlay = false
        this.ProdutosGeral.push({ descricao: 'Novo Produto', icone: true, pkProduto: -1 })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async  Listagem_Lotes_recentes () {
      try {
        //   let  payload =""
        this.overlay = true
        this.lotes = await axios
          .get('/Listagem_lotes_recentes')
          .then(res => res.data)
        this.overlay = false
        this.lotes.push({ descricao: 'Novo Lote', icone: true, pkLote: -1 })
      } catch (error) {
        this.overlay = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async ListagemFaturas () {
      try {
        //   let  payload =""
        this.overlay = true
        this.faturas = await axios
          .get('/Listagem_Recentes_Faturas')
          .then(res => res.data)
        this.overlay = false
        this.faturas.push({ pkFaturaCompra: 0, referencia: 'Nova Factura', icone: true })
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeTipoProdutos () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.tipoProdutos = await axios
          .get('/tipoProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    async initializeMercadoria () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.mercadorias = await axios
          .get('/mercadoriaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeArmazem () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.armazem = await axios
          .get('/armazemFindall')
          .then(res => res.data)
        console.log(this.armazem)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeFamiliaProduto () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.familiaProduto = await axios
          .get('/FamiliaProdutoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeTaxaIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.taxa_iva = await axios
          .get('/TaxaIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb
    async initializeIsencaoIva () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.descricao_isencao_iva = await axios
          .get('/IsencaoIvaFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    async initializePrecosDescricao () {
      try {
        //   let  payload =""
        this.isLoading = true
        this.precosExtensao = await axios
          .get('/precosExtensaoFindall')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // comb

    SelecionaDisponibilidade () {
      if (this.editedItem.disponivel === 2) { this.disabilitaQtd = false } else this.disabilitaQtd = true
    },

    SelecionaLote (indice) {
      let lote = this.Produtos[indice].lote
      let codBarra = this.Produtos[indice].codBarra
      if (lote !== null) {
        if (lote.pkLote > 0) {
          if (this.verificaLoteJaSelecionado(lote, codBarra)) {
            this.mesmoLote = true
            this.text = 'Por favor, selecione um novo lote!'
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          } else {
            let dataValidade = lote.dataValidade.split('T')
            let diasRestantes = utilitarios.ObterNumeroDeDias(utilitarios.ObterDataActural(),dataValidade[0]);
            if( diasRestantes <=0  ){
              Swal.fire('O lote encontra-se expirado','','warning')
              this.Produtos[indice].validade = 'Lote expirado'
              this.loteExpirado = true
            }else{
              this.Produtos[indice].validade = dataValidade[0]
              this.mesmoLote = false
              this.loteExpirado = false
            }
          }
        } else {
          this.showLoteModal = true
          this.Produtos[indice].lote = null
          this.lotes = []
        }
      }
    },

    verificaLoteJaSelecionado (lote, codBarra) {
      let results = this.Produtos.filter(p => p.codBarra === codBarra && p.lote.descricao === lote.descricao).length
      return results > 1
    },

    SelecionaIvaVenda () {
      if (this.taxaIvaVendaSelected !== null) {
        if (this.taxaIvaVendaSelected === 0) {
          this.descricao_isencao_ivaFiltered = this.descricao_isencao_iva
          this.disabilita_ivaVenda = false
        } else {
          this.disabilita_ivaVenda = true
          this.descricao_isencao_ivaFiltered = []
        }
      }
    },

    SelecionaOperacao () {
      if (this.editedItem.operacao === 'Entrada de Stock') {
        this.disabilitaDisponivel = false
      } else {
        this.disabilitaDisponivel = true
      }
    },
    SelecionaProduto (indice) {
      if (this.Produtos[indice].produto.pkProduto > 0) {
        this.preencheCamposByItem(this.Produtos[indice].produto, indice)
      } else {
        this.$store.state.fromStock = true
        this.$router.push('/Novo-Produto')
      }
    },

    SelecionaFornecedor () {

    },

    SelecionaIvaCompra () {
      if (this.taxaIvaCompraSelected !== null) {
        if (this.taxaIvaCompraSelected === 0) {
          this.descricao_isencao_compraFiltered = this.descricao_isencao_iva
          this.disabilita_ivaCompra = false
        } else {
          this.disabilita_ivaCompra = true
          this.descricao_isencao_compraFiltered = []
        }
      }
    },

    SelecionaIvaPreco () {
      if (this.editedItem.impostoIva !== null) {
        if (this.editedItem.impostoIva === 0) {
          this.descricao_isencao_ivaprecoFiltered = this.descricao_isencao_iva
          this.disabilita_ivaPreco = false
        } else {
          this.disabilita_ivaPreco = true
          this.descricao_isencao_ivaprecoFiltered = []
          this.ruleRequiredMotivo = true
        }
        this.CalculaPreComIva(this.editedItem.impostoIva / 100)
      }
    },

    // let valor = utilitarios.MoneyValueToInteger(this.Produtos[indice].precoUnitario)
      // this.Produtos[indice].custoCompra = utilitarios.IntegerToMoneyValue(valor * this.Produtos[indice].qtd)
      // this.Produtos[indice].custoCompraInteiro = (valor * this.Produtos[indice].qtd)
      // this.CalculaTotalGeral()
      // setTimeout(() => {
      //   this.overlay = false
      // }, 100)

    CalculaValorTotal (indice) {
      // this.overlay = true
      // let valorFactura = this.editedItem.faturaCompra.totalFatura
      // let precoUnitario = (valorFactura/this.Produtos[indice].qtd)
      // this.Produtos[indice].precoUnitario = precoUnitario
      // this.overlay = false
    },

    CalculaPrecoUnitario (indice) {
       let custototal = utilitarios.MoneyValueToInteger(this.Produtos[indice].custoCompra)
       let qtd = parseInt(this.Produtos[indice].qtd)
       let precoUnitario = (custototal/qtd).toFixed(2)
       this.Produtos[indice].precoUnitario = utilitarios.IntegerToMoneyValueFatura(precoUnitario) 
       this.CalculaTotalGeral()
    },
    CalculaValorTotalDesconto (indice) {
      this.overlay = true
      let valor = utilitarios.MoneyValueToInteger(this.Produtos[indice].desconto)
      this.Produtos[indice].custoCompra = utilitarios.IntegerToMoneyValue((this.Produtos[indice].custoCompraInteiro - valor) <= 0 ? 0 : (this.Produtos[indice].custoCompraInteiro - valor))
      this.CalculaTotalGeral()
      setTimeout(() => {
        this.overlay = false
      }, 100)
    },

    CalculaTotalGeral () {
      this.totalGeral = 0
      this.Produtos.forEach(element => {
        this.totalGeral += utilitarios.MoneyValueToInteger(element.custoCompra)
      })
    },

    async  SelecionaFatura () {
      if (this.editedItem.faturaCompra.pkFaturaCompra === 0) { // Fez a seleção para o cadastro de uma nova fatura
        this.$router.push('Nova-fatura')
        this.$store.state.fromStock = true
      } else {
        try {
        //   let  payload =""
          let result = await axios
            .get('/SomaVendaTotalPorFatura/' + this.editedItem.faturaCompra.pkFaturaCompra)
            .then(res => res.data)
          if (result.length) {
            this.valorFatura = utilitarios.IntegerToMoneyValue(this.editedItem.faturaCompra.totalFatura)
            this.valorDisponivel = result[0].valorTotal
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },
    async   Save () {
      if (this.$refs.form.validate()) {
        let params =
        {
          pkStock: 0,
          fkProduto: this.editedItem.produto.pkProduto,
          produto: this.editedItem.produto.descricao,
          lote: this.editedItem.lote,
          quantidade: this.editedItem.quantidade,
          dataFab: this.editedItem.dataFabrico,
          dataExp: this.editedItem.dataExpiracao,
          operacao: this.editedItem.operacao,
          observacao: this.editedItem.observacao,
          fkFornecedor: this.editedItem.faturaCompra.fkFornecedor,
          fornecedor: this.editedItem.fornecedor.nome,
          nif: this.editedItem.fornecedor.nif,
          custoCompra: utilitarios.MoneyValueToInteger(this.editedItem.custoCompra),
          custoTransporte: utilitarios.MoneyValueToInteger(this.editedItem.custoTransporte),
          precoUnitario: utilitarios.MoneyValueToInteger(this.editedItem.precoUnitario),
          impostoIva: this.editedItem.impostoIva,
          motivoIsencao: this.editedItem.motivoIsencao,
          fkFatura: this.editedItem.faturaCompra.pkFaturaCompra,
          qtdVenda: this.editedItem.qtdVenda,
          disponiblidadeVenda: this.editedItem.disponivel,
          custoCompraString: this.editedItem.custoCompra,
          custoTransporteString: this.editedItem.custoTransporte,
          stockMinimo: this.editedItem.produto.stock_min,
          stockMaximo: this.editedItem.produto.stock_max
        }

        // === Calcula a soma Total
        let valor = utilitarios.MoneyValueToInteger(this.valorDisponivel)
        let result = parseFloat(valor) + parseFloat(params.custoCompra)
        let valorFatura = utilitarios.MoneyValueToInteger(this.valorFatura)
        if (valorFatura >= result) {
          try {
          //   let  payload =""
            let msg = await axios
              .post('/stockInsertOrUpdate', params)
              .then(res => res.data)

            if (msg.affectedRows >= 1) {
              this.showAlertSucess('Stock actualizado com sucesso!')
              this.valorDisponivel = utilitarios.IntegerToMoneyValue(result)
              this.Limpar()
              this.Produtos = []
            }else{
               Swal.fire('Ocorreu um erro ao tentar efectuar a operação','','error')
            }
          } catch (error) {
            Swal.fire('Ocorreu um erro ao tentar efectuar a operação','','error')
          }finally{
            this.overlay = false
          }
        } else {
          this.showAlertValorCompraAtingida()
        }
      }
    },

    showAlertValorCompraAtingida () {
      this.alert = true
      this.colorAlert = 'color:red;'
      this.iconAlert = 'warning'
      this.alertType = 'warning'
      this.msgAlert = 'Valor de compra atingido!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    showAlertSucess (msg) {
      this.alert = true
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = msg
      setTimeout(() => {
        this.alert = false
      }, 1000)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    SelecionaTipoServico () {
      if (this.tipoProdutoSelected !== null) {
        this.mercadoriasFiltered = this.mercadorias.filter(f => f.fk_tipoProduto === this.tipoProdutoSelected)
        console.log(this.mercadorias)

        this.mercadoria_disable = (this.tipoProdutoSelected !== 1)
      }
    },
    savePreco () {
      if (this.$refs.form.validate()) {
        let params =
          {
            descricaoPreco: (this.model.descricao !== undefined) ? this.model.descricao : this.model,
            margem: this.margemPreco,
            precoSemIva: this.ObterValorFormatado(this.precoSemIva),
            iva: this.taxa_ivaPrecoSelected,
            motivoIsencao: this.motivoIsencao,
            predifinido: this.predifinido,
            precoComIva: this.precoComIva
          }

        this.tabelas_preco.push(params)
        this.dialog = false
      }
    },

    async  RealodStock (item) {
      this.overlay = true

      try {
        //   let  payload =""
        this.isLoading = true
        let msg = await axios
          .get('/deleteStockArmazado/' + item.pkStockGuardado)
          .then(res => res.data)
        if (msg.affectedRows >= 1) {
          setTimeout(() => {
            this.overlay = false
            this.addAgainToStockTable()
            this.InitializeStockGuardado()
            this.dialogStockArmazenado = false
          }, 1000)
        }
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
      console.log(item)
    },

    showItems () {
      this.dialogStockArmazenado = true
    },

    addAgainToStockTable () {
      let fatura = this.stockGuardado[0].fkFatura
      let operacao = this.stockGuardado[0].operacao
      this.editedItem.operacao = (operacao === 1) ? this.operacoesStocks[0] : this.operacoesStocks[1]
      this.editedItem.faturaCompra = this.faturas.filter(f => f.pkFaturaCompra == fatura)[0]
      this.SelecionaFatura()
      let tabela = JSON.parse(this.stockGuardado[0].tabela)
      tabela.forEach(element => {
        this.Produtos.push(element)
      })
    },

    async  saveLote () {
      if (this.$refs.formLote.validate()) {
        let params =
          {
            pkLote: 0,
            descricao: this.editedItemLote.descricao,
            dataValidade: this.editedItemLote.dataValidade,
            dataFabrico: this.editedItemLote.dataFabricacao
          }

        try {
          //   let  payload =""
          this.isLoading = true
          let msg = await axios
            .post('/LoteInsert', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
            this.alertLote = true
            setTimeout(() => {
              this.alertLote = false
              this.showLoteModal = false
            }, 1000)
            this.limparLoteFields()
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    async saveProduto () {
      if (this.$refs.form.validate()) {
        if (this.tabelas_preco.length) {
          let params =
        {
          descricao: this.descricaoProduto,
          descricaoReduzida: this.descricaoReduzida,
          codigoBarra: this.codigoBarraSelected,
          armazem: this.armazemSelected,
          tipoProduto: this.tipoProdutoSelected,
          mercadoria: this.mercadoriaSelected,
          familia: this.familiaSelected,
          precoCusto: this.precoCustoSelected,
          precoComIva: this.precoComIvaInteiro,
          precoSemIva: this.precoSemIva,
          margem: this.margemPreco,
          iva: this.taxa_ivaPrecoSelected,
          isencao: this.motivoIsencao,
          descricaoPreco: (this.model.descricao !== undefined) ? this.model.descricao : this.model,
          pkPreco: (this.model.descricao !== undefined) ? this.model.pkPreco : 0
        }

          try {
            //   let  payload =""
            this.isLoading = true
            let msg = await axios
              .post('/produtoAdd', params)
              .then(res => res.data)

            if (!msg.length) {
              this.alert = true
              this.colorAlert = 'color:green;'
              this.iconAlert = 'done'
              this.alertType = 'success'
              this.msgAlert = 'Produto registrado com sucesso!'
              setTimeout(() => {
                this.alert = false
              }, 4000)
              this.reset()
            }
          } catch (error) {
            this.isLoading = false

            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }
        } else {
          this.alert = true
          this.colorAlert = 'color:red;'
          this.iconAlert = 'warning'
          this.alertType = 'error'
          this.msgAlert = 'Os campos relacionados ao preço do produto devem ser preenchidos!'
          setTimeout(() => {
            this.alert = false
          }, 4000)
        }
      }
    },

    Limpar () {
      this.editedItem = this.editedItemDefault
    },

    limparLoteFields () {
      this.editedItemLote = this.editedItemLoteDefault
    },

    CalculaPreComIva (valor) {
      let valorIva = parseInt(this.precoSemIva) * valor
      let valorFinal = parseInt(this.precoSemIva) + valorIva
      this.precoComIva = valorFinal
      this.precoComIva = this.ObterValorFormatado(valorFinal)
      this.precoComIvaInteiro = valorFinal
    },

    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      return formated.toString().replace('AOA', '')
    },
    saveDataFabrico (date) {
      this.$refs.menuFab.save(date)
      this.editedItemLote.dataFabricacao = date
    },
    saveDataExpiracao (date) {
      this.$refs.menuExp.save(date)
      this.editedItemLote.dataValidade = date
    },
    VerItems (item) {
      this.itemFatura = Object.assign(this.itemFatura, item)
      this.dialogStockArmazenadoItems = true
      this.stockGuardadoItems = JSON.parse(item.tabela)
    },
    async  SaveFactura () {
      if (this.$refs.form.validate()) {
        let params =
         {
           identificador: this.editedItemFactura.numeroFatura,
           valorTotal: utilitarios.MoneyValueToInteger(this.editedItemFactura.valorTotal),
           fileName: (this.editedItemFactura.file !== null) ? this.editedItemFactura.file.name : this.editedItemFactura.file,
           dataCompra: this.dataCompraSelected
         }
        try {
          //   let  payload =""
          this.isLoading = true
          let msg = await axios
            .post('/FacturaCompraAdd', params)
            .then(res => res.data)

          if (!msg.length) {
            this.alert = true
            this.colorAlert = 'color:green;'
            this.iconAlert = 'done'
            this.alertType = 'success'
            this.msgAlert = 'Factura registrada com sucesso!'
            this.dialogFatura = false
            setTimeout(() => {
              this.alert = false
            }, 4000)
          }
        } catch (error) {
          this.isLoading = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    async Guardar () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params =
          {
            pkStockGuardado: 0,
            operacao: this.editedItem.operacao,
            fkFatura: this.editedItem.faturaCompra.pkFaturaCompra,
            fatura: this.editedItem.faturaCompra.referencia,
            produtos: this.Produtos,
            fkFornecedor: this.editedItem.faturaCompra.fkFornecedor,
            iva: this.editedItem.faturaCompra.iva,
            motivoIsencao: this.editedItem.faturaCompra.motivoIsencao,
            custoTransporte: this.editedItem.faturaCompra.custoTransporte,
            fkEntidade: this.editedItem.faturaCompra.fkEntidade
          }
          // this.overlay = true
        try {
          //   let  payload =""
          let msg = await axios
            .post('/stockGuardadoInsertOrUpdate', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
            setTimeout(() => {
              this.overlay = false
              this.showAlertSucess('Dados arzamenados com sucesso')
              this.Limpar()
              this.valorDisponivel = 0
              this.editedItem.operacao = null
              this.editedItem.faturaCompra = null
              this.valorFatura = 0
              this.Produtos = []
              this.InitializeStockGuardado()
            }, 2000)
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    async  Concluir () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params =
          {
            pkStock: 0,
            operacao: this.editedItem.operacao,
            fkFatura: this.editedItem.faturaCompra.pkFaturaCompra,
            produtos: this.Produtos,
            fkFornecedor: this.editedItem.faturaCompra.fkFornecedor,
            iva: this.editedItem.faturaCompra.iva,
            motivoIsencao: this.editedItem.faturaCompra.motivoIsencao,
            custoTransporte: this.editedItem.faturaCompra.custoTransporte,
            fkEntidade: this.editedItem.faturaCompra.fkEntidade
          }
        try {
          //   let  payload =""
          let msg = await axios
            .post('/stockInsertOrUpdate', params)
            .then(res => res.data)
          if (msg.affectedRows >= 1) {
            Swal.fire('Stock actualizado com sucesso.','','success')
               this.overlay = false
               this.Produtos = []
               this.disabilitaOutros = []
               this.editedItem.operacao = ''
               this.editedItem.faturaCompra = ''
               this.resetValidation()
           }
        } catch (error) {
          this.overlay = false
          Swal.fire('Ocorreu um erro ao tentar efectuar a operação.','','error')
        }finally{
           this.overlay = false
        }
      }
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
